export default __webpack_public_path__ + "static/media/landingBgImg.60c6579c.jpg";